/**
 * Cross-tab selected company: localStorage + BroadcastChannel.
 * User-initiated changes call persistUserCompanySelection; hydration / foreign-tab apply use writeStoredCompanyIdOnly.
 */

export const SELECTED_COMPANY_LS_KEY = 'smart_selected_company_id'
export const TAB_ID_SS_KEY = 'smart_tab_instance_id'
export const BROADCAST_CHANNEL_NAME = 'smartcfo-selected-company'

export function getOrCreateTabId() {
  try {
    let id = sessionStorage.getItem(TAB_ID_SS_KEY)
    if (!id) {
      id =
        typeof crypto !== 'undefined' && crypto.randomUUID
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(36).slice(2)}`
      sessionStorage.setItem(TAB_ID_SS_KEY, id)
    }
    return id
  } catch {
    return 'fallback-tab'
  }
}

export function readStoredCompanyId() {
  try {
    return localStorage.getItem(SELECTED_COMPANY_LS_KEY)
  } catch {
    return null
  }
}

export function writeStoredCompanyIdOnly(companyId) {
  if (companyId == null || companyId === '') return
  try {
    localStorage.setItem(SELECTED_COMPANY_LS_KEY, String(companyId))
  } catch {
    // ignore quota / private mode
  }
}

export function clearStoredCompanyId() {
  try {
    localStorage.removeItem(SELECTED_COMPANY_LS_KEY)
  } catch {
    // ignore
  }
}

/**
 * Broadcast only (user tab). Creates a short-lived channel per message so listeners in other tabs receive it.
 */
export function broadcastUserCompanyChange(companyId) {
  if (typeof BroadcastChannel === 'undefined' || companyId == null || companyId === '') return
  try {
    const ch = new BroadcastChannel(BROADCAST_CHANNEL_NAME)
    ch.postMessage({
      v: 1,
      companyId: String(companyId),
      tabId: getOrCreateTabId(),
      ts: Date.now(),
    })
    ch.close()
  } catch {
    // ignore
  }
}

export function persistUserCompanySelection(companyId) {
  writeStoredCompanyIdOnly(companyId)
  broadcastUserCompanyChange(companyId)
}
